import ModalImageMosaic from './ModalImageMosaic';

export default ModalImageMosaic;
